import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import LogoLight from '../../resources/assets/images/bowlscout_logo_text_under.png';
import LogoDark from '../../resources/assets/images/bowlscout_logo_text_under_white.png';
import PoweredBy from '../ui/poweredBy';

const AuthTemplate = ({ children, title, subtitle }) => {
  const theme = useTheme();
  const logo = theme.palette.mode === 'dark' ? LogoDark : LogoLight;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: { xs: 3, sm: 5 },
        background:
          theme.palette.mode === 'dark'
            ? 'radial-gradient(circle at top left, rgba(11, 14, 31, 0.72), transparent 34%), linear-gradient(135deg, #0b0e1f 0%, #18181b 55%, #111827 100%)'
            : 'radial-gradient(circle at top left, rgba(11, 14, 31, 0.1), transparent 34%), linear-gradient(135deg, #f8f9fd 0%, #eef0f8 52%, #f8fafc 100%)'
      }}>
      <Paper
        elevation={theme.palette.mode === 'dark' ? 8 : 2}
        sx={{
          width: '100%',
          maxWidth: 460,
          borderRadius: 3,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'divider'
        }}>
        <Box display="flex" flexDirection="column" alignItems="stretch" p={{ xs: 3, sm: 4 }}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
            <img src={logo} alt="Bowlscout" width={188} />
            {title ? (
              <Typography variant="h5" fontWeight="bold" textAlign="center" mt={3}>
                {title}
              </Typography>
            ) : null}
            {subtitle ? (
              <Typography variant="body2" color="text.secondary" textAlign="center" mt={1}>
                {subtitle}
              </Typography>
            ) : null}
          </Box>
          {children}
          <Box display="flex" justifyContent="center" mt={3}>
          <PoweredBy />
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default AuthTemplate;
